import { useHistory } from "react-router-dom";
import {
  EventAttendeeType,
  EventScheduleResponse,
} from "../../../../../api/event-schedule";
import {
  EventScheduleItemBar,
  EventScheduleListDate,
  EventScheduleListItem,
  EventScheduleListWrapper,
} from "./style";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const KST = "Asia/Seoul";

export interface EventScheduleListProps {
  list: EventScheduleResponse[];
  setCalenderOpen: (v: boolean) => void;
}
const EventScheduleList = ({
  list,
  setCalenderOpen,
}: EventScheduleListProps) => {
  const history = useHistory();
  const formatLabelDate = (dateStr: string) => {
    const newDate = dayjs.tz(dateStr, KST).format("YYYY-MM-DD");

    return `${newDate.split("-")[1]}월 ${newDate.split("-")[2]}일`;
  };

  return (
    <EventScheduleListWrapper>
      {list.length > 0 ? (
        list.map((data, index) => (
          <div key={index} className="list-wrapper">
            <EventScheduleListDate>
              <div className="date">{formatLabelDate(data.date)}</div>
              {index === 0 && (
                <div className="calender" onClick={() => setCalenderOpen(true)}>
                  <img src="/image-web/event/calender.svg" alt="calender" />
                </div>
              )}
            </EventScheduleListDate>
            {data.list.map((item, i) => (
              <>
                {" "}
                <EventScheduleListItem
                  key={i}
                  type={item.attendeeType}
                  onClick={() =>
                    item.link
                      ? history.push(item.link)
                      : history.push(`/store/${item.pubId}?type=PREMIUM`)
                  }
                >
                  <div className={`${item.attendeeType}`}>
                    <div className="img">
                      <img src={item.attendeeImageUrl} alt="크리에이터" />
                    </div>
                  </div>
                  <div className="info">
                    <div className="name">{item.attendeeName}</div>
                    <div className="pub">{item.pubName}</div>
                    <div className="title">
                      {item.title.split("\n").map((line, i) => (
                        <span key={i}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </div>
                  </div>
                </EventScheduleListItem>
                {item.attendeeType === EventAttendeeType.YOUTUBER &&
                  i !== data.list.length - 1 && <EventScheduleItemBar />}
              </>
            ))}
          </div>
        ))
      ) : (
        <>
          <div className="calender" onClick={() => setCalenderOpen(true)}>
            <img src="/image-web/event/calender.svg" alt="calender" />
          </div>
          <div className="no-data">일정이 존재하지 않습니다. </div>
        </>
      )}
    </EventScheduleListWrapper>
  );
};

export default EventScheduleList;
